import { FgStatusEnum } from "@gtpl/shared-models/common-models";
import { LotCodeDropDown } from "@gtpl/shared-models/production-management";
import appSettings from "apps/services/config";
import { EntityRepository, getManager, Repository } from "typeorm";
import { SoSoItemRequest } from "../dto/lot-no-for-so.request";
import { LotCodeOpsEntity } from "../entities/lot-code.entity";
import { UnitTypeEnum } from "@gtpl/shared-models/masters";
@EntityRepository(LotCodeOpsEntity)
export class LotCodeOpsRepository extends Repository<LotCodeOpsEntity> {

  async getLotNumbersForBeheading(): Promise<LotCodeDropDown[]> {
    try {
      const lotCodes: LotCodeDropDown[] = await this.createQueryBuilder('lot_code_data')
        .select('lot_code_ops.lot_code_ops_id as lotCodeOpsId, lot_code_ops.lot_number as lotNumber')
        .where('be_heading IN(:...beHeading)', { beHeading: [FgStatusEnum.OPEN, FgStatusEnum.IN_PROGRESS] })
        .getRawMany();
      return lotCodes
    } catch (error) {
      return error
    }
  }


  async getAllLotNumbers(plantId: number): Promise<LotCodeDropDown[]> {
    try {
      const lotCodes: LotCodeDropDown[] = await this.createQueryBuilder('lot_code_data')
        .select('lot_code_data.lot_code_id as lotCodeOpsId, lot_code_data.lot_number as lotNumber')
        .where(`plant_id='${plantId}'`)
        .getRawMany();
      return lotCodes
    } catch (error) {
      return error
    }
  }

  async getAllLotNumbersForSoItem(req: SoSoItemRequest): Promise<LotCodeDropDown[]> {
    try {
      const lotCode = this.createQueryBuilder('lot_code_data')
        .select('lot_code_data.lot_code_id as lotCodeOpsId, lot_code_data.lot_number as lotNumber')
        .where(`sale_order_id=${req.saleOrderId} and sale_order_item_id=${req.saleOrderItemId} `);

      if (req.plantId) {
        lotCode.andWhere(`plant_id=${req.plantId}`);
      }
      const lotCodes: LotCodeDropDown[] = await lotCode.getRawMany();
      return lotCodes;
    } catch (error) {
      return error
    }
  }

  async getAllLotData(plantId: number) {
    try {
      const manager = getManager();
      const query='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+plantId;
      const result =await manager.query(query);
      // console.log('result[0].plant_type');
      // console.log(result[0].plant_type);
      var lot_query=`select CONCAT(g.lot_number,IF(g.remarks IS NOT NULL, ' - ' ,''),IF(g.remarks IS NOT NULL ,g.remarks , '')) as concatLotNum, lc.lot_code_id as lotCodeOpsId ,lc.grn_date as grnDate,lc.plant_id as plantId,lc.sub_plant_id as subPlantId,lc.indent_no as indentId, lc.grn_number as grnNumber,lc.lot_number as lotNumber,lc.sale_order_id as saleOrderId, lc.sale_order_item_id as saleOrderItemId,lc.supplier_type as supplierType ,lc.farmer as farmer,lc.farmer_code as farmerCode ,lc.quantity as quantity,lc.count as count, lc.price as price ,lc.boxes as boxes  from ` + appSettings.production_db + `.lot_code_data lc LEFT JOIN `+appSettings.rm_procure_db +`.grn_items g ON g.lot_number = lc.lot_number`;     
      if(result[0].plant_type==UnitTypeEnum.SUB_PLANT){
        lot_query+=" where lc.sub_plant_id="+plantId;
      }else{
        lot_query+=" where lc.plant_id="+plantId+' and lc.sub_plant_id = 0';
      }
      const lotData =await manager.query(lot_query);
      // const lotData = await this.createQueryBuilder('lot_code_data')
      //   .where(`plant_id=${plantId}`)
      //   .getMany();
      if (lotData) {
        return lotData
      } else {
        return null
      }
    } catch (error) {
      return error
    }
  }

}